var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 16.047,
    viewBox: "0 0 15 16.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #f5f5f5;\r\n      }\r\n\r\n      .cls-1 {\r\n        clip-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    className: "cls-1",
    d: "M1486.052,712.138h-3v1h4V709.13h-1Zm-3-15.044v1h3v3.009h1v-4.012Zm-10,12.035h-1v4.011h4v-1h-3Zm0-11.032h3v-1h-4v4.012h1Z",
    transform: "translate(-1472.052 -697.095)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    className: "cls-2",
    width: 108.835,
    height: 77.789
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FullScreen",
    transform: "translate(-1472.052 -697.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    className: "cls-3",
    transform: "translate(1472.052 697.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(-62.615 -0.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    className: "cls-2",
    width: 15.697,
    height: 16.744,
    transform: "translate(62.266)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.f0788c572a7c9af950ca59bdd5e136e4.svg";
export { ForwardRef as ReactComponent };